import { userInfoKeys } from '~domains/auth/api/user-info-keys';
import type { UserInfo } from '~domains/auth/model';

import { QueryClient } from '@tanstack/react-query';

import { Permission, permissionsKeys } from '../entities/permissions';

export const getPrefetchedUserInfo = (queryClient: QueryClient) => {
  return queryClient.getQueryData<UserInfo>(userInfoKeys.all());
};

export const getPrefetchedPermissions = (queryClient: QueryClient) => {
  return queryClient.getQueryData<Permission[]>(permissionsKeys.all());
};
